export default __webpack_public_path__ + "icons.c0352072efaa7d6c7576b68fd797bf94.svg";